import RestResource from '../rest.service';

export default class ProjectionGenerateService extends RestResource {
  map(payload) {
    return {
      distributor: payload.distributor,
      previous_campaign: payload.previousCampaign,
      current_campaign: payload.currentCampaign,
      orders_id: payload.ordersId,
    };
  }

  constructor() {
    super('generate/projections');
  }
}
